// extracted by mini-css-extract-plugin
export default {"block":"Filter_block__rn-4Y","blockSelected":"Filter_blockSelected__WpB5m","title":"Filter_title__CHfOs","content":"Filter_content__vbO8r"};